import { styled } from 'styled-components';
import THEME from '../theme.js';
import Well from './Well.js';
// Text primitives for settings panels and their forms
export const Explanation = styled.p `
  margin: 0 0 15px;
  color: #666;
  font-size: 0.9em;
`;
export const EmptyState = styled.div `
  padding: 20px 0;
  text-align: center;
  color: #888;
`;
export const FieldLabel = styled.div `
  margin: 15px 0 5px;
  font-size: 0.85em;
  font-weight: 600;

  &:first-child {
    margin-top: 0;
  }
`;
// Pulls up into the 20px bottom margin of Input and Textarea, which it is
// meant to follow directly
export const Hint = styled.div `
  margin: -12px 0 0;
  color: #888;
  font-size: 0.8em;
`;
export const MetaList = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 10px;
  margin-bottom: ${THEME.GRID_SPACING}px;
`;
export const MetaItem = styled(Well) `
  padding: 8px 14px;

  label {
    display: block;
    font-size: 0.7em;
    font-weight: 900;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${THEME.COLOR_GREY};
    margin-bottom: 2px;
  }

  span {
    font-family: monospace;
    font-size: 0.9em;
    font-weight: 700;
  }
`;
//# sourceMappingURL=PanelText.js.map